import {
    selectFeatureSwitches,
    selectIsFeatureEnabled
} from 'tradera/state/environment/selectors';
import {
    getShippingProvidersByWeight,
    getShippingRecommendations
} from 'tradera/apps/syi/services/shipping-provider-service';
import {
    getSyiSlice,
    selectItemIdFromDraft
} from 'tradera/apps/syi/state/selectors/syi';

import { logger } from 'packages/logger';
import { selectSelectedShippingOptions } from '../reducers/shipping/shipping-selectors';
import { selectShippingRegionCountryCodeIso2 } from 'tradera/state/shipping-region/selectors';
import {
    isDenmarkCountryCode,
    isNetherlandsCountryCode
} from 'tradera/localization/countrycode';
import { trackSyiForm } from 'tradera/apps/syi/services/syi-ga4-service';

const reset = () => ({
    type: 'RESET_SHIPPING_OPTIONS'
});

const resetSelected = () => async (dispatch) => {
    dispatch(setShippingOptionSelected([]));
};

const toggleShippingOption = (type, primary) => (dispatch) => {
    dispatch({
        type: 'TOGGLE_SHIPPING_OPTION',
        payload: {
            type,
            primary
        }
    });
};

const setShippingOptionCost = (cost, primary) => ({
    type: 'SET_SHIPPING_OPTION_COST',
    payload: {
        cost,
        primary
    }
});

const setShippingOptionVariant = (primary, variant) => (dispatch) => {
    dispatch({
        type: 'SET_SHIPPING_OPTION_VARIANT',
        payload: {
            primary,
            variant
        }
    });
};

const setShippingOptionSelected = (options) => (dispatch) => {
    dispatch({
        type: 'SET_SHIPPING_OPTION_SELECTED',
        payload: options
    });
};

const setOfferTakeaway = (offerTakeaway) => async (dispatch) => {
    trackSyiForm({
        eventName: 'syi_pickup',
        parameters: {
            boolean_value: offerTakeaway ? 1 : 0
        }
    });
    dispatch({
        type: 'SET_TAKEAWAY_SELECTED',
        payload: {
            offerTakeaway
        }
    });
};

const setOfferShipping = (offerShipping) => ({
    type: 'SET_SHIPPING_SELECTED',
    payload: {
        offerShipping
    }
});

const getAndSetShippingOptionsByWeight =
    (shippingOptions) => async (dispatch, getState) => {
        try {
            dispatch({
                type: 'SET_SHIPPING_OPTIONS_LOADING'
            });

            const { charity, shipping } = getSyiSlice(getState());
            const itemId = selectItemIdFromDraft(getState());
            const { charityId } = charity;
            let fromCountry = selectShippingRegionCountryCodeIso2(getState());
            if (isDenmarkCountryCode(fromCountry)) {
                fromCountry = shipping.fromCountry;
            } else if (
                isNetherlandsCountryCode(fromCountry) &&
                !selectIsFeatureEnabled('dhl-netherlands-rollout')(getState())
            ) {
                fromCountry = 'se';
            }

            const { data } = await getShippingProvidersByWeight(
                fromCountry,
                charityId,
                itemId
            );
            const { productsPerWeightSpan } = data;

            dispatch({
                type: 'SET_SHIPPING_OPTIONS_BY_WEIGHT',
                payload: {
                    productsPerWeightSpan,
                    shippingOptions:
                        shippingOptions ||
                        selectSelectedShippingOptions(getState())
                }
            });
        } catch (error) {
            dispatch({
                type: 'SET_SHIPPING_OPTIONS_ERROR'
            });
        }
    };

const setShippingRecommendations =
    (categoryId) => async (dispatch, getState) => {
        if (
            selectFeatureSwitches(getState())['shipping-recommendations'] &&
            categoryId
        ) {
            try {
                const { categoryShippingRecommendations } =
                    await getShippingRecommendations(categoryId);
                const { recommendedWeight, shippingRecommendations } =
                    categoryShippingRecommendations;
                dispatch({
                    type: 'SET_SHIPPING_RECOMMENDATIONS',
                    payload: {
                        recommendedWeight,
                        shippingRecommendations
                    }
                });
            } catch (error) {
                dispatch({
                    type: 'CLEAR_SHIPPING_RECOMMENDATIONS'
                });
                logger(
                    'Get ShippingRecommendations failed. Reason: ' +
                        error.message
                );
            }
        }
    };

export const setShippingFromCountry = (payload) => async (dispatch) => {
    dispatch({
        type: 'SET_SHIPPING_FROMCOUNTRY',
        payload
    });
};

export default {
    reset,
    resetSelected,
    setOfferTakeaway,
    setOfferShipping,
    setShippingOptionCost,
    getAndSetShippingOptionsByWeight,
    setShippingOptionVariant,
    setShippingOptionSelected,
    setShippingRecommendations,
    toggleShippingOption,
    setShippingFromCountry
};
